import getApiEndpoint from "./apiEndpoint";

export const brandsAutoComplete = (q = "") =>
  `${getApiEndpoint()}/autocomplete/brands?${q}`;
